import React from "react";

export default function PoweredByFooter({ dark = false }) {
  return (
    <div style={{
      textAlign: "center",
      padding: "12px 0 10px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 6,
      fontSize: 12,
      fontFamily: "inherit",
      color: dark ? "rgba(255,255,255,0.4)" : "#aab7c4",
      userSelect: "none",
      flexShrink: 0,
    }}>
      <span>© Powered by</span>
      <img
        src={dark ? "/Assets/images/iWMSLogo_white.png" : "/Assets/images/iWMS.png"}
        alt="iWMS"
        style={{ height: 14, opacity: 0.7 }}
      />
    </div>
  );
}
